import './styles.scss';//build the styles in scss and then compile to css.
import './calculator-life-insurance.js';//build the styles in scss and then compile to css.
